import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Chip
} from '@material-ui/core'
import {
  History as HistoryIcon,
  DirectionsBike as BikeIcon,
  Person as PersonIcon
} from '@material-ui/icons'
import moment from 'moment'

/**
 * Componente que muestra la tabla de tours anteriores
 * Replica la funcionalidad del tourBookingForm.js
 */
const PreviousToursTable = ({ data }) => {
  const isBeforeToday = (t) => {
    return (
      t.booking &&
      t.booking.tour &&
      moment(t.booking.tour.tour_end_date).isBefore(moment())
    )
  }

  const pastRentals = data && data.pastRentals ? 
    data.pastRentals.filter(isBeforeToday) : []

  const renderTourDates = (tour) => {
    if (!tour) return 'N/A'
    
    const startDate = tour.tour_start_date ? 
      moment(tour.tour_start_date).format('DD/MM/YYYY') : 'N/A'
    const endDate = tour.tour_end_date ? 
      moment(tour.tour_end_date).format('DD/MM/YYYY') : 'N/A'
    
    return `${startDate} - ${endDate}`
  }

  const getVehicleInfo = (rental) => {
    if (!rental.vehicle || rental.vehicle.length === 0) {
      return 'Own - Motorcycle'
    }
    
    const vehicle = rental.vehicle[0]
    const modelName = vehicle.model && vehicle.model.model_name ? 
      vehicle.model.model_name : 'N/A'
    const licensePlate = vehicle.licence_plate || 'N/A'
    const isRenting = vehicle.renting ? '®' : ''
    
    return `${modelName} - ${licensePlate}${isRenting}`
  }

  if (!data || pastRentals.length === 0) {
    return (
      <Paper style={{ padding: 16, marginTop: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <HistoryIcon style={{ marginRight: 8, color: '#ff9800' }} />
          <Typography variant="h6" style={{ color: '#2c3e50', fontWeight: 600 }}>
            Tours Anteriores
          </Typography>
        </div>
        <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 16 }}>
          No hay tours anteriores para mostrar
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper style={{ marginTop: 16, overflow: 'hidden' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        padding: '16px 20px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e9ecef'
      }}>
        <HistoryIcon style={{ marginRight: 8, color: '#ff9800' }} />
        <Typography variant="h6" style={{ color: '#2c3e50', fontWeight: 600 }}>
          Tours Anteriores
        </Typography>
        <Chip 
          label={`${pastRentals.length} tour${pastRentals.length !== 1 ? 's' : ''}`}
          size="small"
          style={{ 
            marginLeft: 'auto',
            backgroundColor: '#ff9800',
            color: 'white',
            fontWeight: 600
          }}
        />
      </div>
      
      <div style={{ overflow: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: '#ff9800' }}>
              <TableCell style={{ 
                color: 'white', 
                fontWeight: 600, 
                fontSize: '0.875rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                ID
              </TableCell>
              <TableCell style={{ 
                color: 'white', 
                fontWeight: 600, 
                fontSize: '0.875rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                TOUR
              </TableCell>
              <TableCell style={{ 
                color: 'white', 
                fontWeight: 600, 
                fontSize: '0.875rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                FIRST NAME
              </TableCell>
              <TableCell style={{ 
                color: 'white', 
                fontWeight: 600, 
                fontSize: '0.875rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                LAST NAME
              </TableCell>
              <TableCell style={{ 
                color: 'white', 
                fontWeight: 600, 
                fontSize: '0.875rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                VEHICLE
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pastRentals.map((rental) => (
              <TableRow key={rental.id} style={{
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor: '#f8f9ff'
                }
              }}>
                <TableCell>
                  <Typography variant="body2" style={{ fontWeight: 600, color: '#2c3e50' }}>
                    #{rental.id}
                  </Typography>
                </TableCell>
                <TableCell>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2" style={{ fontWeight: 600, color: '#2c3e50' }}>
                      {rental.booking.tour.tour_name.tour_name_en}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {renderTourDates(rental.booking.tour)}
                    </Typography>
                  </div>
                </TableCell>
                <TableCell>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <PersonIcon fontSize="small" style={{ marginRight: 4, color: '#666' }} />
                    <Typography variant="body2">
                      {rental.booking.r_first_name || 'N/A'}
                    </Typography>
                  </div>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {rental.booking.r_last_name || 'N/A'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <BikeIcon fontSize="small" style={{ marginRight: 4, color: '#666' }} />
                    <Typography variant="body2">
                      {getVehicleInfo(rental)}
                    </Typography>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Paper>
  )
}

export default PreviousToursTable 


// WEBPACK FOOTER //
// ./src/features/tours/components/PreviousToursTable.js